import { Navigate } from "react-router-dom";
import ProfStats from "../prof/ProfStats";
import PresentationMakerPage from "../prof/presentationTitles/PresentationMakerPage";
import PresentationTitles from "../prof/presentationTitles";
import Students from "../layouts/students";
import QuizSystem from "../prof/QuizSystem";
import HeatMap from "../prof/HeatMap";
import QuizResults from "../prof/QuizResults";
import QuizInsights from "../prof/QuizInsights";
import Icon from "@mui/material/Icon";
import Titles from "../layouts/titles";
import ShowTile from "../layouts/titles/ShowTile";
import ShowThreeD from "../layouts/titles/ShowThreeD";

const profRoutes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <Navigate to="/stats" replace />,
  // },
  {
    type: "collapse",
    name: "Stats",
    key: "stats",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/stats",
    component: <ProfStats />,
  },
  {
    type: "collapse",
    name: "Quiz Insights",
    key: "quiz-insights",
    icon: <Icon fontSize="small">psychology</Icon>,
    route: "/quiz/insights",
    component: <QuizInsights />,
  },
  {
    type: "collapse",
    name: "Students",
    key: "students",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/students",
    component: <Students />,
  },
  {
    type: "collapse",
    name: "3D Models",
    key: "threeDTitles",
    icon: <Icon fontSize="small">view_in_ar</Icon>,
    route: "/threeDTitles",
    component: <Titles type="three_d_model" readOnly />,
  },
  {
    type: "collapse",
    name: "Histology",
    key: "titles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/titles",
    component: <Titles type="his" readOnly />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" readOnly />,
  },



  {
    type: "collapse",
    name: "Presentations",
    key: "presentationTitles",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/presentationTitles",
    component: <PresentationTitles type="presentation" />,
  },

  {
    type: "collapse",
    name: "Quiz",
    key: "quiz",
    icon: <Icon fontSize="small">quiz</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "My Titles",
        key: "quiz-titles",
        route: "/quiz/titles",
        component: <QuizSystem stage={0} />,
      },
      {
        type: "collapse",
        name: "Question Bank",
        key: "quiz-questions",
        route: "/quiz/questions",
        component: <QuizSystem stage={1} />,
      },
      {
        type: "collapse",
        name: "Create Quiz",
        key: "quiz-create",
        route: "/quiz/create",
        component: <QuizSystem stage={2} />,
      },
      {
        type: "collapse",
        name: "Heat map",
        key: "quiz-heatmap",
        route: "/quiz/heatmap",
        component: <HeatMap />,
      },
      {
        type: "collapse",
        name: "Results",
        key: "quiz-results",
        route: "/quiz/results",
        component: <QuizResults />,
      },
    ],
  },

  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">people</Icon>,
  //   route: "/notifications",
  //   component: <PresentationTitles type="presentation" />,
  // },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "presentationMakerPage",
    key: "presentationMakerPage",
    route: "/presentationMakerPage/:id",
    component: <PresentationMakerPage />,
  },
];

export default profRoutes;
